import React from 'react'
import { connect } from 'react-redux';
import { updateBetSlip } from '../../../redux/actions/betSlipActions'
import { SessionStorage } from '../../../helpers';
import { Images } from '../..';



class SpecialOddFieldButton extends React.Component {

    render() {
        const {className, style, text, field, betSlipField,containerStyle } = this.props;
        return (
            <div style={containerStyle}
                
                onClick={e => this.onFieldClick(e, field)}
                className={`SW-Btn`}>
                 <div className={`SW ${betSlipField ? 'selected-odd' : ''}`}>
                     { betSlipField && <img src={Images.Thumb} alt="thumb"/>}
                 </div>
             <span style={style} className={className}>{text}</span>   
            </div>
        )
    }

    onFieldClick(e, field) {
        e.preventDefault();
        e.stopPropagation();

        const { updateBetSlip } = this.props;
        let betTab = SessionStorage.betTab;
        if (betTab == 1) {
            updateBetSlip({ ...field, amount: (!this.props.hideStake && this.props.amount) || 100 });
        }
        else {
            updateBetSlip(field);
        }
        

    }

}

const mapStateToProps = (_, initialProps) => (state) => {
    return {
        eventOddFields: state.sportEvents.eventOddFields,
        betSlipField: state.betSlip.betSlipList[initialProps.oddFieldId],
        amount: state.betSlip.amount,
        hideStake: state.betSlip.hideStake
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateBetSlip: (field) => {
            dispatch(updateBetSlip(field));
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SpecialOddFieldButton)